import React from "react";

/**
 * Shared "glass" surface used for cards/panels across the app so every
 * surface shares the same border, blur, radius and shadow — this is what
 * keeps things feeling solid/consistent instead of ad-hoc per page.
 */
export default function GlassPanel({ as: Tag = "div", className = "", children, ...props }) {
  return (
    <Tag
      className={[
        "relative rounded-3xl border border-white/10 bg-surface-card/55 backdrop-blur-xl shadow-card shadow-inset-line",
        className,
      ].join(" ")}
      {...props}
    >
      {children}
    </Tag>
  );
}
